import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  updateUserProductClaimAction,
  updateUserProductClaimHandler,
} from "../../redux/action/updateUserProductClaim";
import { useCommonMessage } from "../../common/CommonMessage";
import downArrowGrey from "../../assets/images/downArrowGrey.svg";
import { useTranslation } from "react-i18next";
import Loader from "../Loder/loader";
import { getItem } from "../../common/localStorage";
import { getPendingMonthsAction } from "../../redux/action/getPendingMonths";
// import backBtn from "../../assets/images/backBtn.svg";
// import backBtnMobile from "../../assets/images/backBtnMobile.svg";
// import { v4 as uuidv4 } from "uuid";
import { confettiWithHighestZIndex } from "../../common/confettiWithZIndex";
import { getProductFeaturesAction } from "../../redux/action/getProductFeatures";

const Quiz = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  // const [showQuizModal, setShowQuizModal] = useState(false);

  const getCurrentMonth = () => {
    const date = new Date();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear().toString().slice(-2);
    return `${month} '${year}`;
  };

  const getMonths = getCurrentMonth();

  const getClaimMonth = getItem("clickedMonth");

  const isMoreThanOneMonthAgo = (claimMonth) => {
    const currentDate = new Date();
    const [claimMonthStr, claimYear] = claimMonth.split(" '");
    const claimDate = new Date(`${claimMonthStr} 1, 20${claimYear}`);

    const monthDiff =
      (currentDate.getFullYear() - claimDate.getFullYear()) * 12 +
      (currentDate.getMonth() - claimDate.getMonth());

    return monthDiff > 1;
  };

  const messageApi = useCommonMessage();
  const [openIndex, setOpenIndex] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [isModalSaveDrafts, setIsModalSaveDrafts] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showCompareModal, setShowCompareModal] = useState(false);
  const [showMonthMismatchModal, setShowMonthMismatchModal] = useState(false);
  const [tempState, setTempState] = useState([]);
  const [notCompletedQuiz, setNotCompletedQuiz] = useState(false);

  // new work

  const [exisModel, setExisModel] = useState({
    isOpen: false,
    message: "",
  });
  const [optionModel, setOptionModel] = useState({
    isOpen: false,
    message: "",
  });

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [formData, setFormData] = useState(
    state?.itemQuizSet?.setQuestions || []
  );

  const updateUserProductClaimSelector = useSelector(
    (state) => state?.updateUserProductClaim
  );

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleChangeAccourdian = (value, questionText) => {
    setOpenIndex(null);
    // setSelectedOption(value);
    setSelectedOption((prev) => ({
      ...prev,
      [questionText]: value,
    }));
  };

  const [inCorrectAnswerModal, setInCorrectAnswerModal] = useState(false);
  const [readMoreModal, setReadMoreModal] = useState(false);

  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [shownModalIndices, setShownModalIndices] = useState(new Set());

  const handleChange = (e, questionText, questionType, item) => {
    const { value, checked, type } = e.target;

    // Check for incorrect answer only when it's a radio type question
    if (item?.questionType === "radio" && item?.correctAnswer !== value) {
      setInCorrectAnswerModal(true);
      setIncorrectQuestions(item);
      setShownModalIndices((prev) => new Set([...prev, item.index]));
    }

    setSelectedOption((prev) => {
      if (questionType === "radio") {
        return {
          ...prev,
          [questionText]: value,
        };
      } else if (questionType === "checkBox") {
        const currentValue = Array.isArray(prev[questionText])
          ? prev[questionText]
          : [];

        const updatedValue = checked
          ? [...new Set([...currentValue, value])]
          : currentValue.filter((v) => v !== value);

        return {
          ...prev,
          [questionText]: updatedValue,
        };
      }
      return prev;
    });

    setFormData((prevFormData) =>
      prevFormData.map((formItem) => {
        if (formItem.questionText === questionText) {
          if (questionType === "radio") {
            return { ...formItem, userAnswer: value };
          } else if (questionType === "checkBox") {
            const currentAnswers = Array.isArray(formItem.userAnswer)
              ? formItem.userAnswer
              : typeof formItem.userAnswer === "string"
              ? formItem.userAnswer.split(",").map((ans) => ans.trim())
              : [];

            const updatedAnswers = checked
              ? [...new Set([...currentAnswers, value])]
              : currentAnswers.filter((v) => v !== value);
            setTempState(updatedAnswers);
            return { ...formItem, userAnswer: updatedAnswers };
          }
        }
        return formItem;
      })
    );
  };

  useEffect(() => {
    formData.forEach((item, index) => {
      if (
        item.questionType === "radio" &&
        item.userAnswer &&
        item.correctAnswer &&
        item.userAnswer === item.correctAnswer
      ) {
        setShownModalIndices((prev) => {
          const newSet = new Set(prev);
          newSet.delete(index);
          return newSet;
        });
      }
    });
  }, [formData]);

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const showModalSavedrafts = () => {
    setOptionModel({
      isOpen: true,
      message: t("Your quiz is not complete, are you sure you want to leave?"),
    });
  };
  const handleOkSavedrafts = () => {
    setIsModalSaveDrafts(false);
  };
  const handleCancelSavedrafts = () => {
    setIsModalSaveDrafts(false);
  };

  // useEffect(() => {
  //   if (updateUserProductClaimSelector?.message?.statusCode === 417) {
  //     setNotCompletedQuiz(true);
  //     // setShowMonthMismatchModal(false)
  //     // dispatch(updateUserProductClaimAction.updateUserProductClaimInfoReset());
  //   } else if (updateUserProductClaimSelector?.data?.statusCode === 200) {
  //     messageApi.open({
  //       type: "success",
  //       content: updateUserProductClaimSelector?.data?.message,
  //     });

  //     setIsModalOpen(true);
  //     setNotCompletedQuiz(false);
  //     setIsModalSaveDrafts(false);
  //   } else if (updateUserProductClaimSelector?.data?.statusCode === 406) {
  //     messageApi.open({
  //       type: "error",
  //       content: updateUserProductClaimSelector?.data?.message,
  //     });
  //     dispatch(updateUserProductClaimAction.updateUserProductClaimInfoReset());
  //     // navigate("/claims");
  //   }
  // }, [updateUserProductClaimSelector]);
  useEffect(() => {
    if (updateUserProductClaimSelector?.message?.statusCode === 417) {
      setOptionModel({
        isOpen: true,
        message: updateUserProductClaimSelector?.message?.message,
      });
      setExisModel({
        isOpen: false,
        message: "",
      });
    } else if (updateUserProductClaimSelector?.data?.statusCode === 200) {
      setExisModel({
        isOpen: true,
        message: updateUserProductClaimSelector?.data?.message,
      });

      setOptionModel({
        isOpen: false,
        message: "",
      });
      if(updateUserProductClaimSelector?.data?.data?.isSubmit === true){
        // Start confetti only when status code is 200
        confettiWithHighestZIndex();
      }
    }else if(updateUserProductClaimSelector?.message?.statusCode === 406){
      messageApi.open({
        type: "error",
        content: updateUserProductClaimSelector?.message?.message,
      });
      dispatch(updateUserProductClaimAction.updateUserProductClaimInfoReset());
    }
  }, [updateUserProductClaimSelector]);

  
  
  const handleSubmit = (e) => {
    // setSubmitType("submit");

    e.preventDefault();

    const validateAnswers = () => {
      let isValid = true;
      let validationErrors = [];

      formData?.forEach((item) => {
        const userAnswer =
          selectedOption[item?.questionText] || item?.userAnswer;

        // Check if question is answered based on its type
        if (item?.questionType === "dropDownSingle" && !userAnswer) {
          isValid = false;
          validationErrors.push(`${item?.questionText} is required.`);
        }
        if (
          item?.questionType === "dropDownMulti" &&
          (!userAnswer || userAnswer.length === 0)
        ) {
          isValid = false;
          validationErrors.push(`${item?.questionText} is required.`);
        }
        if (item?.questionType === "radio" && !userAnswer) {
          isValid = false;
          validationErrors.push(`${item?.questionText} is required.`);
        }
        if (
          item?.questionType === "checkBox" &&
          (!userAnswer || userAnswer.length === 0)
        ) {
          isValid = false;
          validationErrors.push(`${item?.questionText} is required.`);
        }
      });

      if (!isValid) {
        // Show error toast if there are validation errors
        // messageApi.open({
        //   type: "error",
        //   content: "Please select all answer",
        // });
        setOptionModel({
          isOpen: true,message:t("Your quiz is not complete, are you sure you want to leave?")})
      }

      return isValid;
    };
    if (validateAnswers()) {
      const getUpdatedAnswer = (questionItem, userAnswer) => {
        if (
          questionItem?.questionType === "checkBox" &&
          Array.isArray(userAnswer)
        ) {
          // Remove leading comma if exists
          return tempState.join(",").replace(/^,/, "");
        }
        if (questionItem?.questionType === "radio") {
          return userAnswer || questionItem?.userAnswer;
        }
        if (
          questionItem?.questionType === "dropDownMulti" &&
          Array.isArray(userAnswer)
        ) {
          // Remove leading comma if exists
          return userAnswer.join(",").replace(/^,/, "");
        }
        return userAnswer || questionItem?.userAnswer;
      };

      const updateQuizSet = (quizSet) => {
        return quizSet?.map((setItem) => {
          let attemptedQuestionsCount = 0; // Initialize counter for non-empty userAnswer

          const updatedSetQuestions = setItem?.setQuestions?.map(
            (questionItem) => {
              const userAnswer = selectedOption[questionItem?.questionText];
              const updatedAnswer = getUpdatedAnswer(questionItem, userAnswer);

              if (updatedAnswer !== "") {
                attemptedQuestionsCount++; // Increment count for non-empty answers
              }

              return {
                ...questionItem,
                userAnswer: updatedAnswer,
              };
            }
          );

          // Only update setStatus to 'complete' if both conditions are true:
          const updatedSetStatus =
            setItem?.setName === state?.itemQuizSet?.setName &&
            attemptedQuestionsCount > 0
              ? "complete" // Update to 'complete' if both conditions are true
              : setItem?.setStatus;

          return {
            ...setItem,
            setQuestions: updatedSetQuestions,
            setAttemptedQuestionsCount: attemptedQuestionsCount, // Add attempted count
            // setStatus: updatedSetStatus, // Apply updated status
          };
        });
      };
      const updatedData =
        state?.state?.getUserProductClaimSelector?.data?.data?.claim.map(
          (claim) => {
            if (claim?.id !== state?.state?.item?.id) return claim;

            // Process each quizSet and determine if all setStatus are "complete"
            const updatedQuizData = claim?.quizData?.map((quizItem) => {
              const updatedQuizSet = updateQuizSet(quizItem?.quizSet);
              const allSetsComplete = updatedQuizSet.every(
                (setItem) => setItem?.setStatus === "complete"
              );
              return {
                ...quizItem,
                quizSet: updatedQuizSet,
                // quizStatus:"complete"
              };
            });
            const allQuizComplete = updatedQuizData.every((quizItem) =>
              quizItem?.quizSet?.every(
                (setItem) => setItem?.setStatus === "complete"
              )
            );
            return {
              ...claim,
              // claimStatus:"COMPLETE",
              quizData: updatedQuizData,
            };
          }
        );
      const payload = {
        id: state?.state?.getUserProductClaimSelector?.data?.data?.id,
        isSubmit: true,
        claimId: state?.state?.item?.id,
        quizSetId: state?.itemQuizSet?.id,
        quizSetIndex: state?.indexQuizSet,
        claim: updatedData,
        claimType: state?.state?.item?.claimType,
      };
      dispatch(updateUserProductClaimHandler(payload));
    }
  };
  

  const saveAsDraftFunction = (e) => {
    // setSubmitType("draft");

    e.preventDefault();

    const getUpdatedAnswer = (questionItem, userAnswer1) => {
      if (
        questionItem?.questionType === "checkBox" &&
        Array.isArray(userAnswer1)
      ) {
        return userAnswer1.join(",");
      }
      if (questionItem?.questionType === "radio") {
        return userAnswer1 || questionItem?.userAnswer;
      }
      if (
        questionItem?.questionType === "dropDownMulti" &&
        Array.isArray(userAnswer1)
      ) {
        return userAnswer1.length > 0 ? userAnswer1.join(",") : "";
      }
      return userAnswer1;
    };

    const updatedData =
      state?.state?.getUserProductClaimSelector?.data?.data?.claim.map(
        (claim) => {
          if (claim?.id !== state?.state?.item?.id) return claim;

          return {
            ...claim,
            // claimStatus: "DRAFT", // Setting claim status to DRAFT
            quizData: claim?.quizData?.map((quizItem) => ({
              ...quizItem,
              quizSet: quizItem?.quizSet?.map((setItem) => {
                if (setItem?.setName === state?.itemQuizSet?.setName) {
                  let attemptedQuestionsCount = 0;
                  const updatedSetQuestions = setItem?.setQuestions?.map(
                    (questionItem) => {
                      const userAnswer = formData.find(
                        (item) =>
                          item.questionText === questionItem?.questionText
                      )?.userAnswer;

                      const userAnswer1 = selectedOption[
                        questionItem?.questionText
                      ]
                        ? selectedOption[questionItem?.questionText]
                        : questionItem?.userAnswer;

                      const updatedAnswer = getUpdatedAnswer(
                        questionItem,
                        userAnswer1
                      );

                      if (updatedAnswer !== "") {
                        attemptedQuestionsCount++;
                      }

                      return {
                        ...questionItem,
                        userAnswer: updatedAnswer,
                      };
                    }
                  );

                  return {
                    ...setItem,
                    // setStatus: "DRAFT",
                    setQuestions: updatedSetQuestions,
                    setAttemptedQuestionsCount: attemptedQuestionsCount,
                  };
                }

                return setItem;
              }),
            })),
          };
        }
      );
    const payload = {
      id: state?.state?.getUserProductClaimSelector?.data?.data?.id,
      claim: updatedData,
      isSubmit: false,
      claimId: state?.state?.item?.id,
      quizSetId: state?.itemQuizSet?.id,
      quizSetIndex: state?.indexQuizSet,
      claimType: state?.state?.item?.claimType,
    };
    dispatch(updateUserProductClaimHandler(payload));
  };

  // const date = new Date();
  // const previousMonthDate = new Date(
  //   date.getFullYear(),
  //   date.getMonth() - 1,
  //   1
  // );

  // const showThankyouModal = () => {
  //   const previousMonthDateFormated =
  //     moment(previousMonthDate).format("MMM 'YY");

  //   const currentClaimMonth = state?.getPendingMonthsSelector?.find(
  //     (item) => item?.value === getMonths
  //   );
  //   if (
  //     getClaimMonth === currentClaimMonth?.value &&
  //     currentClaimMonth?.status === "pending" &&
  //     updateUserProductClaimSelector?.data?.data?.isSubmit === true
  //   ) {
  //     setShowCompareModal(true);
  //     setIsModalOpen(false);
  //   } else if (
  //     getClaimMonth === previousMonthDateFormated &&
  //     currentClaimMonth?.status === "pending" &&
  //     updateUserProductClaimSelector?.data?.data?.isSubmit === true
  //   ) {
  //     setShowMonthMismatchModal(true);
  //     setIsModalOpen(false);
  //   } else {
  //     setIsModalOpen(false);
  //     navigate("/claims");
  //     dispatch(updateUserProductClaimAction.updateUserProductClaimInfoReset());
  //     dispatch(getPendingMonthsAction.getPendingMonthsInfoReset());
  //   }
  // };

  // const showThankyouModal = () => {
  //   if (
  //     updateUserProductClaimSelector?.data?.data?.popUpMessage !== "" ||
  //     updateUserProductClaimSelector?.data?.data?.popUpMessage === undefined
  //   ) {
  //     // setShowCompareModal(true);
  //     setIsModalOpen(true);
  //     navigate("/claims");
  //     // setShowMonthMismatchModal(true)
  //     setShowMonthMismatchModal(false);
  //     // dispatch(updateUserProductClaimAction.updateUserProductClaimInfoReset());
  //     // dispatch(getPendingMonthsAction.getPendingMonthsInfoReset());
  //   } else if (
  //     updateUserProductClaimSelector?.data?.data?.popUpMessage === ""
  //   ) {
  //     navigate("/claims");
  //     setIsModalSaveDrafts(false);
  //     dispatch(updateUserProductClaimAction.updateUserProductClaimInfoReset());
  //     dispatch(getPendingMonthsAction.getPendingMonthsInfoReset());
  //   }
  // };

  // const showThankyouModal = () => {
  //   if (updateUserProductClaimSelector?.data?.data?.popUpMessage !== "") {
  //     setOptionModel({
  //       isOpen: false,
  //       message: updateUserProductClaimSelector?.data?.data?.popUpMessage,
  //     });
  //   }
  // };

  return (
    <>
      {updateUserProductClaimSelector?.isLoading && (
        <Loader loaderTransform="loaderTransform" />
      )}
      <div className="py-50 mobileMargin">
        <div className="container">
          <div className="d-flex align-center justify-between mb-20 mobileHide">
            <div>
              <div className="tgb fs-20 mb-12">{t("Quiz")}</div>
              <p className="m-0">{t("Discussion and Multiple Choice form")}</p>
            </div>
            <button
              className="saveDraft cursor-pointer"
              onClick={showModalSavedrafts}
            >
              {t("Save as Draft")}
            </button>
          </div>
          <form onSubmit={handleSubmit}>
            {formData?.map((item, index) => (
              <div className="quizCard" key={index}>
                <div className="quizTitle">{item?.questionText}</div>
                <div className="radio-group">
                  {/* Dropdown with single select */}
                  {item?.questionType === "dropDownSingle" && (
                    <div className="position-relative">
                      <div
                        className={`inputField active ${
                          openIndex === index ? "rotate focus" : ""
                        }`}
                        onClick={() => handleToggle(index)}
                      >
                        <span>
                          {selectedOption[item?.questionText] ||
                            selectedOption[index] ||
                            item?.userAnswer ||
                            "Choose from options"}
                        </span>
                        <img
                          src={downArrowGrey}
                          alt=""
                          className="dropdownArrow"
                        />
                      </div>
                      <div
                        className="menuState"
                        style={{
                          display: openIndex === index ? "block" : "none",
                        }}
                      >
                        {item?.answerChoice?.map((option, optionIndex) => (
                          <div
                            key={optionIndex}
                            onClick={() =>
                              handleChangeAccourdian(option, item?.questionText)
                            }
                            className="cursor-pointer"
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {/* dropdown with multiple select */}
                  {item?.questionType === "dropDownMulti" && (
                    <div className="position-relative">
                      <Select
                        mode="multiple"
                        defaultValue={
                          (item?.userAnswer
                            ? item?.userAnswer.split(",")
                            : []) ||
                          selectedOption[item?.questionText] ||
                          selectedOption[index] ||
                          []
                        }
                        onChange={(value) =>
                          handleChangeAccourdian(value, item?.questionText)
                        }
                        style={{ width: "100%" }}
                      >
                        {item?.answerChoice?.map((option, index) => (
                          <Select.Option key={index} value={option}>
                            {option}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  )}
                  {/* Only render when question type is radio */}
                  {item?.questionType !== "dropDownSingle" &&
                    item?.questionType !== "dropDownMulti" &&
                    item?.answerChoice?.map((choice, choiceIndex) => (
                      // <label className="custom-radio" key={choiceIndex}>
                      <label
                        className={
                          item?.questionType === "radio"
                            ? "custom-radio"
                            : "customCheckbox"
                        }
                        key={choiceIndex}
                      >
                        <input
                          type={item?.questionType}
                          value={choice}
                          checked={
                            item?.questionType === "radio"
                              ? item?.userAnswer === choice
                              : Array.isArray(item?.userAnswer)
                              ? item?.userAnswer.includes(choice)
                              : String(item?.userAnswer)
                                  ?.split(",")
                                  .map((ans) => ans.trim())
                                  .includes(choice)
                          }
                          onChange={(e) =>
                            handleChange(
                              e,
                              item?.questionText,
                              item?.questionType,
                              item
                            )
                          }
                        />
                        <div
                          className={
                            item?.questionType === "radio"
                              ? "radio-checkmark"
                              : "checkbox-checkmark"
                          }
                        ></div>
                        {choice}
                      </label>
                    ))}
                </div>
              </div>
            ))}
            <div className="text-end ">
              <button
                className="saveBtn w-100 cursor-pointer"
                //   onClick={showModal}
              >
                {t("Submit")}
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* Thank you for submitting quiz || Quiz Saved To Draft*/}
      {isModalOpen && (
        <Modal
          className="ok-modal2"
          centered
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          closeIcon={null}
          maskClosable={false}
        >
          <div className="tgb fs-20 lh-25 mb-40 text-center">
            {updateUserProductClaimSelector?.data?.message}
          </div>
          <div className="text-center">
            <button
              className="saveBtn cursor-pointer"
              // onClick={() => {
              //   navigate("/claims");
              //   dispatch(
              //     updateUserProductClaimAction.updateUserProductClaimInfoReset()
              //   );
              // }}
              // onClick={showThankyouModal}
            >
              {t("Okay")}
            </button>
          </div>
        </Modal>
      )}

      {/* When get incorrect answer */}
      {inCorrectAnswerModal && (
        <Modal
          className="ok-modal2"
          centered
          open={inCorrectAnswerModal}
          onOk={() => setInCorrectAnswerModal(false)}
          onCancel={() => setInCorrectAnswerModal(false)}
          footer={null}
          closeIcon={null}
          maskClosable={false}
        >
          <div className="tgb fs-20 lh-25 mb-40 text-center">
            {t(incorrectQuestions?.errorMessage)}
          </div>
          <div className="yesNoOption">
            <button
              className="noBtn"
              onClick={() => setInCorrectAnswerModal(false)}
            >
              {t("Okay")}
            </button>
            <button
              className="yesBtn"
              onClick={() => {
                setInCorrectAnswerModal(false);
                setReadMoreModal(true);
              }}
            >
              {t("Read more")}
            </button>
          </div>
        </Modal>
      )}
      {/* Thank you next month modal */}
      {showCompareModal && (
        <Modal
          className="ok-modal2"
          centered
          open={showCompareModal}
          footer={false}
          closeIcon={null}
          maskClosable={false}
        >
          <div className="tgb fs-20 lh-25 mb-40 text-center">
            {t("Thank you! See you next month!")}
          </div>
          <div className="text-center">
            <button
              className="saveBtn cursor-pointer "
              onClick={() => {
                setShowCompareModal(false);
                navigate("/claims");
                dispatch(
                  updateUserProductClaimAction.updateUserProductClaimInfoReset()
                );
              }}
            >
              {t("Okay")}
            </button>
          </div>
        </Modal>
      )}

      {/* Read More Modal */}
      {readMoreModal && (
        <Modal
          className="ok-modal2 readMoreModal"
          centered
          open={readMoreModal}
          footer={false}
          closeIcon={null}
          maskClosable={false}
        >
          <div className="tgb fs-20 lh-25 mb-40 ">{t("Description")}</div>
          <div className="mb-40">
            <div className=" ">
              <div className="  fs-20  descriptionScroll">
                {t(
                  incorrectQuestions?.wrongAnswerDescription ||
                    "No description found"
                )}
              </div>
            </div>
          </div>
          <button
            className="saveBtn cursor-pointer "
            onClick={() => {
              setReadMoreModal(false);
            }}
          >
            {t("Continue with Quiz")}
          </button>
        </Modal>
      )}

      {/* Quiz not completed Modal  Completed new logic*/}
      {(notCompletedQuiz || optionModel?.isOpen) && (
        <>
          {updateUserProductClaimSelector?.isLoading ? (
            <Loader loaderTransform="loaderTransform" />
          ) : (
            <>
              <Modal
                className="ok-modal2 readMoreModal"
                centered
                open={notCompletedQuiz || optionModel?.isOpen}
                footer={false}
                closeIcon={null}
                maskClosable={false}
              >
                <div className="tgb fs-20 lh-25 mb-40 text-center">
                  {/* {t(updateUserProductClaimSelector?.message?.message)} */}
                  {updateUserProductClaimSelector?.message?.statusCode === 417
                    ? updateUserProductClaimSelector?.message?.message
                    : optionModel?.message}
                </div>

                <div className="yesNoOption">
                  <button className="noBtn" onClick={saveAsDraftFunction}>
                    {t("Disregard")}
                  </button>
                  <button
                    className="yesBtn"
                    onClick={() => {
                      setNotCompletedQuiz(false);
                      setIsModalSaveDrafts(false);
                      setOptionModel({ isOpen: false, message: "" });
                    }}
                  >
                    {t("Return to quiz")}
                  </button>
                </div>
              </Modal>
            </>
          )}
        </>
      )}

      {exisModel?.isOpen && (
        <>
          {updateUserProductClaimSelector?.isLoading ? (
            <Loader loaderTransform="loaderTransform" />
          ) : (
            <>
              <Modal
                className="ok-modal2 readMoreModal"
                centered
                open={exisModel?.isOpen}
                footer={false}
                closeIcon={null}
                maskClosable={false}
              >
                <div className="tgb fs-20 lh-25 mb-40 text-center">
                  {/* {t(updateUserProductClaimSelector?.message?.message)} */}
                  {exisModel?.message}
                </div>

                <div className="text-center">
                  <button
                    className="saveBtn cursor-pointer "
                    onClick={() => {
                      dispatch(getProductFeaturesAction.getProducteaturesReset());
                        if(updateUserProductClaimSelector?.data?.data?.popUpMessage === exisModel?.message){
                          setExisModel({isOpen:false, message:""});
                          navigate("/claims");
                          dispatch(
                            updateUserProductClaimAction.updateUserProductClaimInfoReset()
                          );
                          dispatch(getPendingMonthsAction.getPendingMonthsInfoReset());
                        }
                        else if(updateUserProductClaimSelector?.data?.data?.popUpMessage !==""&&updateUserProductClaimSelector?.data?.data?.popUpMessage !==undefined){

                          setExisModel({ isOpen: true, message: updateUserProductClaimSelector?.data?.data?.popUpMessage });
                              
                          // navigate("/claims");
                        } else {
                          navigate("/claims");
                          setExisModel({ isOpen: false, message: "" });
                          dispatch(
                            updateUserProductClaimAction.updateUserProductClaimInfoReset()
                          );
                          dispatch(getPendingMonthsAction.getPendingMonthsInfoReset());
                        }
                    }}
                  >
                    {t("Okay")}
                  </button>
                </div>
              </Modal>
            </>
          )}
        </>
      )}

      {/* Month mismatch modal */}
      {showMonthMismatchModal &&
        updateUserProductClaimSelector?.data?.data?.popUpMessage !== "" && (
          <Modal
            className="ok-modal2"
            centered
            open={showMonthMismatchModal}
            footer={false}
            closeIcon={null}
            maskClosable={false}
          >
            <div className="tgb fs-20 lh-25 mb-40 text-center">
              {/* {t(
              `Great! Thank you for taking care of that! Now, let's get you caught up and complete your Qualifying Claim event for ${getMonths}.`
            )} */}
              {updateUserProductClaimSelector?.data?.data?.popUpMessage}
            </div>
            <div className="text-center">
              <button
                className="saveBtn cursor-pointer "
                onClick={() => {
                  setShowMonthMismatchModal(false);
                  navigate("/claims");
                  dispatch(
                    updateUserProductClaimAction.updateUserProductClaimInfoReset()
                  );
                  dispatch(getPendingMonthsAction.getPendingMonthsInfoReset());
                }}
              >
                {t("Okay")}
              </button>
            </div>
          </Modal>
        )}
    </>
  );
};

export default Quiz;
